module.exports = __webpack_public_path__ + "static/media/permission-lock.229f784b.svg";